import type { GUID } from '@/types/common.types';
import type { LanguagesEnum } from '@/utils/enums/Languages';

export enum PackageType {
  BRONZE = 'bronz',
  GOLD = 'gold',
}

export enum PackageCategory {
  TYT = 'tyt',
  AYT = 'ayt',
  LGS = 'lgs',
}

export enum PackageCurrency {
  TRY = 'TRY',
  USD = 'USD',
}

export interface IPackagePrice {
  id: GUID;
  createdAt: string;
  packageID: GUID;
  currency: PackageCurrency;
  fullPrice: number;
  netPrice: number;
  discountRate: number;
  isActive: boolean;
}

export interface IPackageLocale {
  id: GUID;
  createdAt: string;
  packageID: GUID;
  language: LanguagesEnum;
  name: string;
  description: string;
  properties: string;
  about: string;
  listImage: string;
  detailImage: string;
}

export interface Package {
  id: GUID;
  createdAt: string;
  canUseCoupon: boolean;
  category: PackageCategory;
  currency: PackageCurrency;
  discountRate: number;
  fullPrice: number;
  isActive?: boolean;
  isFeatured: boolean;
  netPrice: number;
  packageLessons: {
    departmentName: string;
    gradeName: string;
    lessonName: string;
    lesson: {
      name: string;
    };
  }[];
  packageType: PackageType;
  packageLocales: IPackageLocale[];
  packagePrices: IPackagePrice[];
}

export interface ISubscription {
  id: GUID;
  createdAt: string;
  userID: GUID;
  packageID: GUID;
  tokenID: GUID;
  startDate: string;
  endDate: string;
  distanceSalesContract: string;
  preInformationForm: string;
  package: Package;
  receipt: string;
}
